import { Field } from '@/ui'
import { Field as FormikField } from 'formik'
import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

const FORM_NAME = {
	okedCode: 'okedCode',
}

export const AddAdditionalOkedForm = memo(() => {
	const { t } = useTranslation()

	const { okeds } = useSelector((state) => ({
		okeds: state.handbook.okeds,
	}))

	return (
		<div>
			<FormikField name={FORM_NAME.okedCode}>
				{({ field, meta: { touched, error } }) => {
					return (
						<Field
							{...field}
							isRequired
							type="text"
							fieldType='select'
							label={t('ckp_OKED')}
							placeholder={t('choose_from_directory')}
							options={okeds}
							error={touched && error}
						/>
					)
				}}
			</FormikField>
		</div>
	)
})